import React, { useEffect } from 'react';

import { useHistory, useParams } from "react-router-dom";

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

import PaymentForm from './PaymentForm';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
}));

const PaymentDetailWrapper = (props) => {
    const {
        payment,
    } = props;

    const history = useHistory();
    const handleSaveButtonClick = () => {
        history.push('/admin/payments');
    }

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid item xs={12}>
                <PaymentForm
                    couple={payment.wedding}
                    payment={payment}
                    paymentId={payment.id}
                    paymentNumber={payment.payment_number}
                    handleSaveButtonClick={handleSaveButtonClick}
                />
            </Grid>
        </Grid>
    )
}

const PaymentDetail = () => {
    const { id } = useParams();
    const classes = useStyles();

    const [payment, setPayment] = React.useState({});

    function handleBackClick() {
        window.history.back();
    }

    useEffect(() => {
        document.title = 'Edit Payment - Enduring Promises';

        /* TODO: add loader? */

        new Promise((resolve, reject) => {
            let url = `/api/payments/${id}`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    if (result.payment_number) {
                        setPayment(result);
                        document.title = `Edit Payment ${result.payment_number} - Enduring Promises`;
                    } else {
                        setPayment({error:404});
                    }
                    resolve();
                })
        });
    }, [id]);

    return (
        <div>
            <Box mb={2}>
                <Button startIcon={<Icon>chevron_left</Icon>} onClick={handleBackClick} size="small" variant="outlined" color="primary">Back</Button>
            </Box>
            <Paper square>
                <Box className={classes.root}>
                    {payment.id !== undefined && <PaymentDetailWrapper payment={payment} />}
                    {payment.error !== undefined && <p>No payment found</p>}
                </Box>
            </Paper>
        </div>
    );
}

export default PaymentDetail;
